import React, {useState, useRef, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import PremiumSettingsWizard from "../../components/PremiumSettings/premiumSettingsWizard";
import {
	changePremiumSettingsWizardStore, changePremiumSettingsWizardStoreByDamageAndCaseStage,
	changePremiumSettingsWizardStoreByDamageCaseStageAndSolicitor,
	changeWizardStep, getPremiumSettingsWizardStepMessages, postNewPremiumSettingWizard, getCoverageTypes,
} from "../../actions/premiumSettingsWizard";
import {requestLawsysFirmsFiltered, changeLawsysFirmState} from "../../actions/lawsysFirms";
import {changeApplicationPolicySettings} from "../../actions/applicationPolicy";
import {
	requestGetSpecificPremiumSetting,
	requestPatchPremiumSetting,
	requestPremiumSettingsDamages,
	requestPremiumSettingsStages,
} from '../../actions/premiumSettings';
import _ from 'lodash';
import {getCaseTypes} from "../../actions/caseTypes";
import moment from "moment";
import {CANADA_COUNTRY, COUNTRY, CURRENCY} from "../../helpers/variables";
import {
	areEntitiesWithIdsEqual,
	getRouterSearchParam,
	redirectToHandler,
	formattedMoney,
	isAgentOutsideAragProvider,
	resolveEditedSolicitorGroupAragProvider,
	resolveSelectedSolicitorGroupInfo,
	isPlcProviderCode,
} from '../../helpers/functions';
import { useDecimalErrors } from '../../hooks/useAmountField';
import { goBack as routerGoBack } from 'connected-react-router';
import { useLocation, useHistory } from 'react-router-dom';
import {clearSuccessMsg} from "../../helpers/utilMessage";
import { editablePremiumSettingsColumns, readonlyPremiumSettingsTableColumns } from '../../helpers/utilFunctions';
import { isContingentCommissionLocked } from '../../helpers/premiumEditLock';
import {requestPatchApplicationPremiumSettings} from "../../actions/applicationPolicy";
import {
	CLINICAL_NEGLIGENCE_MN,
	COMMISSION, COMMISSION_PERCENTAGE, CONTINGENT, INITIAL_OPTIONS, MOMENT_DATE_FORMAT, NON_CONTINGENT,
	NON_RECOVERABLE, PREMIUM, PREMIUM_TYPE, PS_TYPE_CUSTOM,
	PS_TYPE_PERCENTAGE, RECOVERABLE, UNDERWRITER_RATE, UNDERWRITER_RATE_PERCENTAGE,
	APPLICATION_PREMIUM_SETTINGS_LOI_TEST_ID, APPLICATION_PREMIUM_SETTINGS_NOTES_TEST_ID,
	APPLICATION_PREMIUM_SETTINGS_COMMENTS_TEST_ID, APPLICATION_PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID,
	PREMIUM_SETTINGS_LOI_TEST_ID, PREMIUM_SETTINGS_NOTES_TEST_ID,
	PREMIUM_SETTINGS_COMMENTS_TEST_ID, PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID,
	PREMIUM_SETTINGS_WIZARD_LOI_TEST_ID, PREMIUM_SETTINGS_WIZARD_NOTES_TEST_ID,
	PREMIUM_SETTINGS_WIZARD_COMMENTS_TEST_ID, PREMIUM_SETTINGS_WIZARD_ENDORSEMENTS_TEST_ID,
	APPLICATION_PREMIUM_SETTINGS_TABLE_TEST_ID, PREMIUM_SETTINGS_TABLE_TEST_ID, PREMIUM_SETTINGS_WIZARD_TABLE_TEST_ID,
	PREMIUM_SETTINGS_URL,
	LOCALE_UK,
	EMPHASIZED_FIELDS,
	HIGHLIGHTED_FIELDS,
	APPLICATION_PREMIUM_SETTINGS_COVERAGE_TEST_ID,
	APPLICATION_PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID,
	PREMIUM_SETTINGS_COVERAGE_TEST_ID,
	PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID,
	PREMIUM_SETTINGS_WIZARD_DEDUCTIBLE_TEST_ID,
	PREMIUM_SETTINGS_WIZARD_COVERAGE_TEST_ID,
	PREMIUM_SETTINGS_COPY_FROM_PARAM,
} from '../../helpers/constants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import {
	handleCommissionChange,
	handlePercentagePremiumTableChange,
	handlePremiumAndUnderwriterChange,
	handleRecoverableAndNonRecoverableChange,
	safeParseFloat,
	validatePremiumTable,
	sortDamageBands,
	areDamagesNeighbors,
	getDamageBandName,
	calculateGroupColumns,
	calculateOuterVerticalHeaders,
	calculateVerticalHeaders,
	handlePremiumSettingsTableData,
	checkIfPercentagePremium,
	getTableHeaderData,
	isDefaultCommissionAddDisabled,
	isDefaultPremiumSettingFlow,
} from '../../helpers/premiumSettingsFunctions';
import { 
	applicationPremiumSettingsShowTableFields, 
	buildRevisionTableProps, 
	handleAnnotatedPremiumSettingsTableData
} from '../../helpers/applicationPremiumSettingsFunctions';
import { FEATURE_FLAGS } from '../../constants/configurationKeys';
import useFeatureFlag from '../../hooks/useFeatureFlag';

const PremiumSettingsWizardHOC = (props) => {

	const {
		match,
		showTable,
		isApplicationPremium,
		isChangingStatusOfApp,
		applicationPremiumCancelHandler,
		applicationPremiumSaveButtonLabel,
		onApplicationPremiumEdit,
		selectedApplicationCaseTypeId,
		loggedInUser,
		onCancel,
	} = props;

	// Feature flags
	const showNonContingentToggle = useFeatureFlag(FEATURE_FLAGS.NON_CONTINGENT_STAGES_ENABLED);
	const defaultPremiumSettingsCommissionsEnabled = useFeatureFlag(FEATURE_FLAGS.DEFAULT_PREMIUM_SETTINGS_COMMISSIONS_ENABLED);
	const [emptyField, setEmptyField] = useState('');
	const { errors: tableErrors, checkDecimal: checkTableDecimal, clearAll: clearTableErrors } = useDecimalErrors();
	const [selectedPreviousUpdate, setSelectedPreviousUpdate] = useState(null);
	const askServerRef = useRef(null);
	const dispatch = useDispatch();
    const location = useLocation();
	const history = useHistory();
	
	const premiumSettingsWizard = useSelector(state => state.premiumSettingsWizard);
	const premiumSettings = useSelector(state => state.premiumSettings);
	const lawsysFirms = useSelector(state => state.lawsysFirms);
	const damages = useSelector(state => state.damages.damages);
	const damagesSortOrders = useSelector(state => state.damages.damagesSortOrders);
	const fetchingDamages = useSelector(state => state.damages.fetchingDamages);
	const caseStages = useSelector(state => state.premiumSettings.stages);
	const fetchingStages = useSelector(state => state.premiumSettings.fetchingStages);
	const selectedSolicitorGroup = useSelector(state => state.premiumSettings.selectedSolicitorGroup);
	const selectedCaseTypeRedux = useSelector(state => state.premiumSettings.selectedCaseType);
	const selectedSubCaseType = useSelector(state => state.premiumSettings.selectedSubCaseType);
	const caseTypes = useSelector(state => state.caseTypes.cases);
	const fetchingCaseTypes = useSelector(state => state.caseTypes.fetching);
	const selectedWorksource = useSelector(state => state.premiumSettings.selectedWorksource);
	const selectedSolicitorGroupName = useSelector(state => state.premiumSettings.selectedSolicitorGroupName);
	const selectedSolicitorGroupAragProvider = useSelector(state => state.premiumSettings.selectedSolicitorGroupAragProvider);
	const selectedWorksourceName = useSelector(state => state.premiumSettings.selectedWorksourceName);
	const premiumSettingType = useSelector(state => state.premiumSettings.psType);
	const applicationId = useSelector(state => state.applicationsAndPolicies.selectedApplication.id);
	const pig = useSelector(state => state.applicationsAndPolicies.selectedApplication.pig);
	const policyStatusMachineName = useSelector(state => state.applicationsAndPolicies.selectedApplication.policyStatusMachineName);
	// WI 97790. Gated on isApplicationPremium so the global Premium Settings page - which shares this
	// wizard but has no policy context - is never locked by a stale selectedApplication in the store.
	const lockContingentCommission = isApplicationPremium
		&& isContingentCommissionLocked({ policyStatusMachineName, pig });
	const onApplyPig = () => dispatch(changeApplicationPolicySettings('openApplyPigModal', true));
	const sendEmail = useSelector(state => state.applicationPolicy.sendEmailNotification);
	const appliedIndex = useSelector(state => state.applicationPolicy?.premiumSettings?.appliedApplicationPremiumSubSettingsDtoIndex);
	const highlightColumnPropertyName = appliedIndex >= 0 ? `premiumCharge${appliedIndex}` : null;
	const appPremiumSettingsIndicator = useSelector(state => state.applicationPolicy.premiumSettingsIndicator);
	const isPercentagePremium = checkIfPercentagePremium(premiumSettingType, premiumSettingsWizard.isPercentagePremium);
	// Single signal for "does this setting have solicitor-group scope" - shared by the Add New
	// Commission button (below) and the Non-Contingent lock so the two agree on what "Default" means.
	// Tracks whichever field the save actually posts - premiumSettingsWizard.solicitorGroupId in edit
	// mode (including the Application Premium Settings fetch), selectedSolicitorGroup when creating/copying
	// - because editHandle clears selectedSolicitorGroup for PS_TYPE_DEFAULT, so keying off it in edit
	// mode would miss a genuine Default-with-group setting's real, posted group id.
	const hasSolicitorGroup = premiumSettingsWizard.isEditMode
		? !!premiumSettingsWizard.solicitorGroupId
		: !!selectedSolicitorGroup;
	const isDefaultPremiumSetting = isDefaultPremiumSettingFlow({ premiumSettingType, isApplicationPremium }) && !hasSolicitorGroup;
	// WI: "Enable/disable commission agents on Default Premium Settings" - gates the Add New
	// Commission button on Step 3. Only applies to the source Default Premium Setting flow, not
	// Custom/Percentage settings and not Application Premium Settings (out of scope for this switch
	// even though isApplicationPremium reuses this same wizard).
	const commissionAddDisabled = isDefaultCommissionAddDisabled({
		premiumSettingType,
		isApplicationPremium,
		featureEnabled: defaultPremiumSettingsCommissionsEnabled,
		hasSolicitorGroup,
	});
	const highlightedContingentStageMachineName = useSelector(
		state => state.applicationPolicy?.premiumSettings?.highlightedContingentStageMachineName ?? null
	);
	const highlightedNonContingentStageMachineName = useSelector(
		state => state.applicationPolicy?.premiumSettings?.highlightedNonContingentStageMachineName ?? null
	);

	// Single source of truth for "which group is this, and what do we need to know about it" - the ARAG
	// provider id (commission-agent filtering, step 3) and GPL classification (Underwriter Rate/Amount
	// lock, AC1/AC2/AC3) always come from the same resolution so every caller below describes the same
	// group. The application-premium flow has no selected-group context of its own (that dropdown belongs
	// to the standalone Premium Settings list page) - it reads both fields straight off the store, fetched
	// alongside the rest of the application premium setting.
	const selectedSolicitorGroupInfo = isApplicationPremium
		? {
			aragProviderId: premiumSettingsWizard.solicitorGroupAragProviderId ?? null,
			isGplSolicitorGroup: !!premiumSettingsWizard.isGplSolicitorGroup,
			// WI 99823 - "not GPL" also catches Canada, so the Application Premium Settings surface uses
			// the provider code (PremiumSettingsDto.SolicitorGroupAragProviderCode) to identify PLC.
			isPlcSolicitorGroup: isPlcProviderCode(premiumSettingsWizard.solicitorGroupAragProviderCode),
		}
		: resolveSelectedSolicitorGroupInfo(premiumSettingsWizard, premiumSettings.solicitorGroups, selectedSolicitorGroup);

	// WI 99823 AC1/AC2/AC4: Non-Contingent is locked for a PLC group and for a Default Premium Setting
	// with no solicitor-group scope (see isDefaultPremiumSetting above - a category of its own in the
	// US intro). The wizard never shows or posts a Non-Contingent row while locked: step1.js forces
	// the checkbox off and the column hidden, and effectiveTableData (below) strips Non-Contingent
	// rows from the submitted payload. The server-side reject in PremiumSettingsService /
	// ApplicationService is the save-time backstop for raw API posts.
	const nonContingentLocked = selectedSolicitorGroupInfo.isPlcSolicitorGroup || isDefaultPremiumSetting;

	// Convenience dispatch wrappers (used frequently throughout)
	const changeStoreSettings = (key, value) => {
		dispatch(changePremiumSettingsWizardStore(key, value));
	};

	const changeStore2 = (field, value, tableIndex) => {
		dispatch(changePremiumSettingsWizardStoreByDamageAndCaseStage(field, value, tableIndex));
	};

	const changeStore3 = (field, value, tableIndex, solicitorId) => {
		dispatch(changePremiumSettingsWizardStoreByDamageCaseStageAndSolicitor(field, value, tableIndex, solicitorId));
	};

	// Mount effect (replaces componentWillMount)
	useEffect(() => {
		if (COUNTRY === CANADA_COUNTRY) {
			dispatch(getCoverageTypes());
		}

		// "Create New Based On Current": the source setting id arrives as ?copyFrom=<id>, read from
		// the React Router location. Shared with the staged create flow
		// (stagedPremiumSettingsCreateHOC) - same param, same reader - covering every setting type.
		const copyFromId = getRouterSearchParam(location?.search, PREMIUM_SETTINGS_COPY_FROM_PARAM);
		if (copyFromId) {
			dispatch(requestGetSpecificPremiumSetting({
				premiumSettingId: copyFromId,
				isEditMode: false,
				premiumSettingTypePercentage: isPercentagePremium
			}));
			dispatch(getPremiumSettingsWizardStepMessages());
			return;
		}

		// Edit mode — route param
		if (match?.params?.id) {
			dispatch(requestGetSpecificPremiumSetting({
				premiumSettingId: match.params.id,
				isEditMode: true,
				premiumSettingTypePercentage: isPercentagePremium
			}));
			dispatch(getPremiumSettingsWizardStepMessages());
			return;
		}

		// Default — fetch all needed data
		if (!showTable) {
			dispatch(requestPremiumSettingsDamages());
			dispatch(getCaseTypes());
		}
		dispatch(requestPremiumSettingsStages());
		dispatch(getPremiumSettingsWizardStepMessages());
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	// Debounced solicitor search (replaces componentDidUpdate)
	useEffect(() => {
		if (lawsysFirms.suggestionFieldValue && lawsysFirms.suggestionFieldValue.length >= 3) {
			askServerRef.current = setTimeout(() => {
				dispatch(requestLawsysFirmsFiltered({
					search: lawsysFirms.suggestionFieldValue,
				}));
			}, 500);
		}
		return () => clearTimeout(askServerRef.current);
	}, [lawsysFirms.suggestionFieldValue]); // eslint-disable-line react-hooks/exhaustive-deps

	
    useEffect(() => {
        if (!isApplicationPremium && premiumSettingsWizard.successMsg !== '') {
            redirectToHandler(PREMIUM_SETTINGS_URL, history, premiumSettingsWizard.successMsg);
        }
    }, [isApplicationPremium, premiumSettingsWizard.successMsg, history]);

	// --- Stage selection handlers ---

	const handleCaseStagesSelectMultipleChange = (isChecked, stage) => {
		let newStages = [];
		if (!isChecked && (stage.name === 'Pre-Issue')) {
			// Allow deselecting Contingent Pre-Issue ONLY when:
			// 1. Non-contingent toggle is ON
			// 2. NC Pre-Issue is selected
			// 3. No other contingent stages are selected (only Pre-Issue remains)
			const { hasNonContingentPremium, selectedNonContingentCaseStages, selectedCaseStages } = premiumSettingsWizard;
			const ncPreIssueSelected = selectedNonContingentCaseStages.some(s => s.name === 'Pre-Issue');
			const onlyPreIssueInContingent = selectedCaseStages.length === 1 && selectedCaseStages[0].name === 'Pre-Issue';

			if (!(hasNonContingentPremium && ncPreIssueSelected && onlyPreIssueInContingent)) {
				return;
			}
		}

		if (isChecked) {
			newStages = [...premiumSettingsWizard.selectedCaseStages, stage];
			// If Pre-Issue was deselected and user is adding another stage, re-add Pre-Issue
			const preIssueSelected = newStages.some(s => s.name === 'Pre-Issue');
			if (!preIssueSelected) {
				const preIssueStage = caseStages.find(s => s.name === 'Pre-Issue');
				if (preIssueStage) {
					newStages = [preIssueStage, ...newStages];
				}
			}
		} else {
			newStages = premiumSettingsWizard.selectedCaseStages.filter(item => item.id !== stage.id);
		}

		changeStoreSettings('selectedCaseStages', newStages);
	};

	const handleCaseStagesCheckedState = (stageId) => {
		try {
			return !!premiumSettingsWizard.selectedCaseStages.find(item => item.id === stageId);
		} catch (e) {
			return false;
		}
	};

	const handleToggleNonContingent = (isChecked) => {
		if (isChecked) {
			// Auto-select Pre-Issue in NC list
			const preIssueStage = caseStages.find(s => s.name === 'Pre-Issue');
			changeStoreSettings('hasNonContingentPremium', true);
			changeStoreSettings('selectedNonContingentCaseStages', preIssueStage ? [preIssueStage] : []);
		} else {
			// Clear NC selections
			changeStoreSettings('hasNonContingentPremium', false);
			changeStoreSettings('selectedNonContingentCaseStages', []);

			// Re-select and re-lock Contingent Pre-Issue if it was deselected
			const contingentPreIssueSelected = premiumSettingsWizard.selectedCaseStages.some(s => s.name === 'Pre-Issue');
			if (!contingentPreIssueSelected) {
				const preIssueStage = caseStages.find(s => s.name === 'Pre-Issue');
				if (preIssueStage) {
					changeStoreSettings('selectedCaseStages', [
						...premiumSettingsWizard.selectedCaseStages,
						preIssueStage
					]);
				}
			}
		}
	};

	const handleNonContingentCaseStagesChange = (isChecked, stage) => {
		// NC Pre-Issue is always locked — block deselection
		if (!isChecked && stage.name === 'Pre-Issue') {
			return;
		}

		let newStages = [];
		if (isChecked) {
			newStages = [...premiumSettingsWizard.selectedNonContingentCaseStages, stage];
		} else {
			newStages = premiumSettingsWizard.selectedNonContingentCaseStages.filter(item => item.id !== stage.id);
		}

		changeStoreSettings('selectedNonContingentCaseStages', newStages);
	};

	const handleNonContingentCaseStagesCheckedState = (stageId) => {
		try {
			return !!premiumSettingsWizard.selectedNonContingentCaseStages.find(item => item.id === stageId);
		} catch (e) {
			return false;
		}
	};

	// --- Damage band methods ---

	const getDamagesNotInDamageBands = () => {
		let damageBands = [...premiumSettingsWizard.damageBands];
		let allDamages = [...damages];
		let damagesInDamageBands = [];
		let damagesNotInDamageBands = [];
		if (damageBands.length === 0)
			return allDamages;
		if (damageBands.length === 1) {
			if (damageBands[0].length === allDamages.length) {
				return [];
			}
		}
		for (let i = 0; i < damageBands.length; i++) {
			damagesInDamageBands = [...damagesInDamageBands, ...damageBands[i]];
		}
		for (let i = 0; i < allDamages.length; i++) {
			let item = _.find(damagesInDamageBands, (item) => {
				return item.id === allDamages[i].id;
			});
			if (!item) {
				damagesNotInDamageBands = [...damagesNotInDamageBands, allDamages[i]];
			}
		}
		damagesNotInDamageBands = _.orderBy(damagesNotInDamageBands, (item) => item.sortOrder);
		return damagesNotInDamageBands;
	};

	const setDamageBand = () => {
		let damageBands = [...premiumSettingsWizard.damageBands];
		let allDamages = [...damages];
		let startOfDamageBand = premiumSettingsWizard.startOfDamageBand;
		let endOfDamageBand = premiumSettingsWizard.endOfDamageBand;
		let startOfDamageBandObject = _.find(allDamages, (item) => item.id.toString() === startOfDamageBand);
		let endOfDamageBandSortObject = _.find(allDamages, (item) => item.id.toString() === endOfDamageBand);
		let newDamageBand = [];
		let newDamageBands = [];

		if (!endOfDamageBandSortObject) {
			return null;
		}
		if (startOfDamageBandObject && endOfDamageBandSortObject) {
			_.forEach(allDamages, damage => {
				if (startOfDamageBandObject.sortOrder <= damage.sortOrder && (damage.sortOrder <= endOfDamageBandSortObject.sortOrder)) {
					newDamageBand.push(damage);
				}
			});
		}
		else if (startOfDamageBandObject) {
			newDamageBand.push(startOfDamageBandObject);
		}
		else {
			return null;
		}
		if (damageBands.length === 1) {
			if (damageBands[0].length === allDamages.length) {
				newDamageBands = [newDamageBand];
			}
			else {
				newDamageBands = [...damageBands, newDamageBand];
			}
		}
		else {
			newDamageBands = [...damageBands, newDamageBand];
		}

		let damagesInDamageBands = [];
		let damagesNotInDamageBands = [];
		if (newDamageBands.length === 0)
			return allDamages;
		if (newDamageBands.length === 1) {
			if (newDamageBands[0].length === allDamages.length) {
				changeStoreSettings('damageBands', [allDamages]);
				changeStoreSettings('openDamageBandModal', false);
				changeStoreSettings('selectedDamages', []);
				changeStoreSettings('checkedDamagesIds', []);
				return false;
			}
		}
		for (let i = 0; i < newDamageBands.length; i++) {
			damagesInDamageBands = [...damagesInDamageBands, ...newDamageBands[i]];
		}
		for (let i = 0; i < allDamages.length; i++) {
			let item = _.find(damagesInDamageBands, (item) => {
				return item.id === allDamages[i].id;
			});
			if (!item) {
				damagesNotInDamageBands = [...damagesNotInDamageBands, allDamages[i]];
			}
		}
		damagesNotInDamageBands = _.orderBy(damagesNotInDamageBands, (item) => item.sortOrder);
		let finalDamageBands = [...newDamageBands];
		if (damagesNotInDamageBands.length > 0) {
			if (newDamageBands.length === 0) {
				changeStoreSettings('damageBands', [allDamages]);
			}
			else {
				if (newDamageBands.length === 1) {
					if (newDamageBands[0].length === allDamages.length) {
						changeStoreSettings('damageBands', [allDamages]);
						dispatch(changeWizardStep('increase'));
						return null;
					}
				}
				let tempDamageBand = [];
				_.forEach(damagesNotInDamageBands, (item, index) => {
					if (index === 0) {
						tempDamageBand.push(item);
						if (index + 1 === damagesNotInDamageBands.length) {
							finalDamageBands.push(tempDamageBand);
							tempDamageBand = [];
						}
					}
					else if (index + 1 === damagesNotInDamageBands.length) {
						if (areDamagesNeighbors(damagesSortOrders, damagesNotInDamageBands[index - 1].sortOrder, item.sortOrder)) {
							tempDamageBand.push(item);
							finalDamageBands.push(tempDamageBand);
						}
						else {
							if (tempDamageBand.length > 0) { finalDamageBands.push(tempDamageBand); }
							finalDamageBands.push([item]);
						}
						tempDamageBand = [];
					}
					else if (areDamagesNeighbors(damagesSortOrders, damagesNotInDamageBands[index - 1].sortOrder, item.sortOrder)) {
						tempDamageBand.push(item);
					}
					else if (!areDamagesNeighbors(damagesSortOrders, damagesNotInDamageBands[index - 1].sortOrder, item.sortOrder)) {
						finalDamageBands.push(tempDamageBand);
						tempDamageBand = [item];
					}
				});
				changeStoreSettings('damageBands', sortDamageBands(finalDamageBands));
			}
		} else {
			changeStoreSettings('damageBands', sortDamageBands(finalDamageBands));
		}

		changeStoreSettings('openDamageBandModal', false);
		changeStoreSettings('selectedDamages', []);
		changeStoreSettings('checkedDamagesIds', []);
	};

	const getStartDamageBands = () => {
		return [{key: '', value: ''}, ...getDamagesNotInDamageBands().map(damage => {
			return {key: damage.id, value: formattedMoney(damage.lowValue, CURRENCY, 0) };
		})];
	};

	const getEndDamageBands = () => {
		let allDamages = [...damages];
		let startOfDamageBand = premiumSettingsWizard.startOfDamageBand;
		let startOfDamageBandObject = _.find(allDamages, (item) => item.id.toString() === startOfDamageBand);
		let damagesNotInDamageBandsLocal = getDamagesNotInDamageBands();
		let filtered1 = [];
		if (startOfDamageBandObject) {
			filtered1 = _.filter(damagesNotInDamageBandsLocal, item => {
				return (item.sortOrder >= startOfDamageBandObject.sortOrder);
			});
		}
		let filtered2 = [];
		if (filtered1.length > 0) {
			_.forEach(filtered1, (item, index) => {
				if (index === 0) {
					filtered2.push(item);
				}
				else if (index <= filtered1.length) {
					if (areDamagesNeighbors(damagesSortOrders, filtered1[index - 1].sortOrder, item.sortOrder)) {
						filtered2.push(item);
					}
					else return false;
				}
			});
		}
		if (damagesNotInDamageBandsLocal.length > 0 && startOfDamageBandObject) {
			return [...INITIAL_OPTIONS, ...filtered2.map(damage => {
				return {
					key: damage.id,
					value: damage.highValue ? formattedMoney(damage.highValue, CURRENCY, 0) : CONTENT_STRINGS.UNLIMITED
				};
			})];
		}
		else {
			return [];
		}
	};

	const removeDamageBand = (damageBandIndex) => {
		let damageBands = [...premiumSettingsWizard.damageBands];
		damageBands.splice(damageBandIndex, 1);
		changeStoreSettings('damageBands', damageBands);
	};

	// --- Solicitor methods ---

	const addSolicitor = () => {
		// The same firm the modal disables its Add button on, so the two can never disagree about a
		// selection; the store lookup only covers a selection made before that field was populated.
		const selectedFirm = lawsysFirms.selectedLawsysFirmsDropdown[0]
			?? _.find(lawsysFirms.lawsysFirms,
				item => item.id.toString() === premiumSettingsWizard.selectedSolicitor.toString());
		// Nothing resolved means nothing to add - bailing keeps an undefined entry out of the list.
		if (!selectedFirm) return;
		// The modal only offers agents of the group's provider, so this is the last stop rather than the
		// first - it keeps a stale store entry from reaching a save the server would reject later.
		if (isAgentOutsideAragProvider(selectedFirm, selectedSolicitorGroupInfo.aragProviderId)) return;
		const solicitorsList = [...premiumSettingsWizard.solicitorsList, selectedFirm];
		changeStoreSettings('solicitorsList', _.sortBy(solicitorsList, ['id']));
		changeStoreSettings('openSolicitorModal', false);
		dispatch(changeLawsysFirmState('suggestionFieldValue', ''));
		dispatch(changeLawsysFirmState('lawsysFirmsFiltered', []));
		dispatch(changeLawsysFirmState('selectedLawsysFirmsDropdown', []));
		changeStoreSettings('selectedSolicitor', '');
	};

	const removeSolicitor = (solicitorIndex) => {
		let solicitorsList = [...premiumSettingsWizard.solicitorsList];
		solicitorsList.splice(solicitorIndex, 1);
		changeStoreSettings('solicitorsList', solicitorsList);
	};

	// --- Table data methods ---

	// WI 97790: a frozen contingent cell renders as plain text, so a new stage / damage band / commission
	// agent seeded with '' shows as £0.00 with no input to correct and validatePremiumTable then refuses the
	// save. Seed those cells at 0 instead. Restricted contingent rows only - everywhere else '' is what makes
	// the empty-field validation force the user to fill a genuinely new cell in.
	const frozenContingentValue = (value) =>
		(lockContingentCommission && (value === '' || value == null)) ? 0 : value;

	const setStorePremiumSettingsObject = () => {
		let tableData = [];
		// GPL AC1/AC2 - the Underwriter Rate/Amount cells render disabled for a Green/LEI group, so a
		// blank seed would be both unfillable and rejected by validatePremiumTable's empty-field check,
		// making a brand-new Custom/Percentage setting unsubmittable. Seeding 0 keeps the render lock,
		// the wizard state and the submit payload (which clamps to 0 anyway) all agreeing on the same value.
		const isGpl = selectedSolicitorGroupInfo.isGplSolicitorGroup;
		_.forEach(premiumSettingsWizard.damageBands, (damageBand, index) => {
			let damageBandIndex = index;
			let dmgs = [];
			_.forEach(damageBand, band => {
				dmgs.push({ id: band.id });
			});
			// Contingent stages
			_.forEach(premiumSettingsWizard.selectedCaseStages, caseStage => {
				const sector = premiumSettingsWizard.tableData.find(data => {
					return (
						data.stageId === caseStage.id &&
						areEntitiesWithIdsEqual(damageBand, data.damages) &&
						!data.isNonContingent
					);
				});

				let premiumSubSettingCommissions = [];
				_.forEach(premiumSettingsWizard.solicitorsList, solicitor => {
					const sectorMatch = sector ?
						sector.premiumSubSettingCommissions.find(item => item.lawsysId === solicitor.id) : null;
					premiumSubSettingCommissions.push({
						lawsysId: solicitor.id,
						lawsysName: solicitor.name,
						aragProvider: solicitor.aragProvider,
						commission: frozenContingentValue(sectorMatch ? sectorMatch.commission : ''),
						commissionPercentage: frozenContingentValue(sectorMatch ? sectorMatch.commissionPercentage : '')
					});
				});
				tableData.push({
					stageName: caseStage ? caseStage.name : null,
					stageId: caseStage.id,
					stageSortOrder: caseStage ? caseStage.sortOrder : 0,
					premium: sector ? sector.premium : '',
					recoverable: sector ? sector.recoverable : '',
					nonRecoverable: sector ? sector.nonRecoverable : '',
					underwriterRate: frozenContingentValue(sector ? sector.underwriterRate : (isGpl ? 0 : '')),
					underwriterRatePercentage: frozenContingentValue(sector ? sector.underwriterRatePercentage : (isGpl ? 0 : '')),
					premiumSubSettingCommissions: premiumSubSettingCommissions,
					damages: dmgs,
					damageBandIndex: damageBandIndex,
					premiumType: CONTINGENT,
					isNonContingent: false,
				});
			});

			// Non-contingent stages
			if (premiumSettingsWizard.hasNonContingentPremium) {
				_.forEach(premiumSettingsWizard.selectedNonContingentCaseStages, caseStage => {
					const sector = premiumSettingsWizard.tableData.find(data => {
						return (
							data.stageId === caseStage.id &&
							areEntitiesWithIdsEqual(damageBand, data.damages) &&
							!!data.isNonContingent
						);
					});

					let premiumSubSettingCommissions = [];
					_.forEach(premiumSettingsWizard.solicitorsList, solicitor => {
						const sectorMatch = sector ?
							sector.premiumSubSettingCommissions.find(item => item.lawsysId === solicitor.id) : null;
						premiumSubSettingCommissions.push({
							lawsysId: solicitor.id,
							lawsysName: solicitor.name,
							aragProvider: solicitor.aragProvider,
							commission: sectorMatch ? sectorMatch.commission : '',
							commissionPercentage: sectorMatch ? sectorMatch.commissionPercentage : ''
						});
					});
					tableData.push({
						stageName: caseStage ? caseStage.name : null,
						stageId: caseStage.id,
						stageSortOrder: caseStage ? caseStage.sortOrder : 0,
						premium: sector ? sector.premium : '',
						recoverable: sector ? sector.recoverable : '',
						nonRecoverable: sector ? sector.nonRecoverable : '',
						underwriterRate: sector ? sector.underwriterRate : (isGpl ? 0 : ''),
						underwriterRatePercentage: sector ? sector.underwriterRatePercentage : (isGpl ? 0 : ''),
						premiumSubSettingCommissions: premiumSubSettingCommissions,
						damages: dmgs,
						damageBandIndex: damageBandIndex,
						premiumType: NON_CONTINGENT,
						isNonContingent: true,
					});
				});
			}
		});
		tableData = _.orderBy(tableData, ['isNonContingent', 'stageSortOrder']);
		changeStoreSettings('tableData', tableData);
	};

	// --- Step submission handlers ---

	const handleSubmitStep1 = (evt) => {
		evt.preventDefault();
		dispatch(changeWizardStep('increase'));
	};

	const handleSubmitStep2 = (evt) => {
		evt.preventDefault();
		let damagesNotInDamageBandsLocal = getDamagesNotInDamageBands();
		let damageBands = [...premiumSettingsWizard.damageBands];
		let allDamages = [...damages];
		let finalDamageBands = [...damageBands];
		if (damagesNotInDamageBandsLocal.length > 0) {
			if (damageBands.length === 0) {
				changeStoreSettings('damageBands', [allDamages]);
			}
			else {
				if (damageBands.length === 1) {
					if (damageBands[0].length === allDamages.length) {
						changeStoreSettings('damageBands', [allDamages]);
						dispatch(changeWizardStep('increase'));
						return null;
					}
				}
				let tempDamageBand = [];
				_.forEach(damagesNotInDamageBandsLocal, (item, index) => {
					if (index === 0) {
						tempDamageBand.push(item);
						if (index + 1 === damagesNotInDamageBandsLocal.length) {
							finalDamageBands.push(tempDamageBand);
							tempDamageBand = [];
						}
					}
					else if (index + 1 === damagesNotInDamageBandsLocal.length) {
						if (areDamagesNeighbors(damagesSortOrders, damagesNotInDamageBandsLocal[index - 1].sortOrder, item.sortOrder)) {
							tempDamageBand.push(item);
							finalDamageBands.push(tempDamageBand);
						}
						else {
							if (tempDamageBand.length > 0) { finalDamageBands.push(tempDamageBand); }
							finalDamageBands.push([item]);
						}
						tempDamageBand = [];
					}
					else if (areDamagesNeighbors(damagesSortOrders, damagesNotInDamageBandsLocal[index - 1].sortOrder, item.sortOrder)) {
						tempDamageBand.push(item);
					}
					else if (!areDamagesNeighbors(damagesSortOrders, damagesNotInDamageBandsLocal[index - 1].sortOrder, item.sortOrder)) {
						finalDamageBands.push(tempDamageBand);
						tempDamageBand = [item];
					}
				});
				changeStoreSettings('damageBands', sortDamageBands(finalDamageBands));
			}
		}
		dispatch(changeWizardStep('increase'));
	};

	const handleSubmitStep3 = (evt) => {
		evt.preventDefault();
		setStorePremiumSettingsObject();
		dispatch(changeWizardStep('increase'));
	};

	const scrollToError = () => {
		const inputElements = document.querySelectorAll('input[type="text"], input[type="number"]');
		let firstInvalidInput = null;
		for (const input of inputElements) {
			if (input.value === '' || input.value === null || input.value === undefined) {
				firstInvalidInput = input;
				break;
			}
		}
		if (firstInvalidInput) {
			firstInvalidInput.scrollIntoView({
				behavior: 'smooth',
				block: 'center'
			});
			firstInvalidInput.focus();
		}
	};

	const handleSubmitStep4 = (evt) => {
		evt.preventDefault();
		const isTableValid = validatePremiumTable(
			premiumSettingsWizard.tableData,
			changeStoreSettings,
			getSelectedCaseType(),
			(message) => setEmptyField(message)
		);
		if (isTableValid) {
			dispatch(changeWizardStep('increase'));
			setEmptyField('');
			clearTableErrors();
		} else {
			scrollToError();
		}
	};

	const handleSubmitPercentageStep4 = (evt) => {
		evt.preventDefault();
		const isPercentagePremium = true;
		let isTableValid = validatePremiumTable(
			premiumSettingsWizard.tableData,
			changeStoreSettings,
			getSelectedCaseType(),
			(message) => setEmptyField(message),
			isPercentagePremium
		);
		if (isTableValid) {
			dispatch(changeWizardStep('increase'));
			setEmptyField('');
			clearTableErrors();
		} else {
			scrollToError();
		}
	};

	const handleSubmitStep5 = (evt) => {
		evt.preventDefault();

		if (
			!isApplicationPremium
			&& moment(premiumSettingsWizard.validFrom, MOMENT_DATE_FORMAT)
				.isBefore(moment().startOf('day'))
		) {
			changeStoreSettings('validationMessageStep5', CONTENT_STRINGS.VALID_FROM_DATE_CANNOT_BE_IN_THE_PAST);
			return false;
		}
		if (
			!isApplicationPremium
			&& premiumSettingsWizard.validUntil
			&& moment(premiumSettingsWizard.validUntil, MOMENT_DATE_FORMAT)
				.isBefore(moment(premiumSettingsWizard.validFrom, MOMENT_DATE_FORMAT))
		) {
			changeStoreSettings('validationMessageStep5', CONTENT_STRINGS.VALID_UNTIL_DATE_CANNOT_BE_BEFORE_VALID_FROM_DATE);
			return false;
		}
		clearTableErrors();
		dispatch(changeWizardStep('increase'));
	};

	// --- Premium sub-setting builder ---

	const getPremiumSubSetting = () => {
		let sendItem = [];
		const isGplSolicitorGroup = selectedSolicitorGroupInfo.isGplSolicitorGroup;
		// WI 99823 AC4: iterate effectiveTableData (Non-Contingent rows stripped when nonContingentLocked),
		// not the raw store value, so a locked setting reached directly at step 6 (currentStep: 6 from
		// RECEIVE_/CHANGE_PREMIUM_SETTINGS_WITH_COMBINATION) never posts a legacy Non-Contingent row. Same
		// filtered value the step 4 render uses, so the two surfaces stay in step.
		_.forEach(effectiveTableData, data => {
			let premiumSubSettings = [];
			_.forEach(data.premiumSubSettingCommissions, subSettings => {
				const commission = safeParseFloat(subSettings.commission);
				const commissionPercentage = safeParseFloat(subSettings.commissionPercentage);
				premiumSubSettings.push({
					commission: premiumSettings.psType === PS_TYPE_PERCENTAGE ? 0 : commission,
					commissionPercentage: commissionPercentage,
					lawsysId: subSettings.lawsysId
				});
			});
			const premium = safeParseFloat(data.premium);
			const underwriterRate = safeParseFloat(data.underwriterRate);
			const underwriterRatePercentage = safeParseFloat(data.underwriterRatePercentage);
			const recoverable = safeParseFloat(data.recoverable);
			const nonRecoverable = safeParseFloat(data.nonRecoverable);
			const isClinicalNegligence = getSelectedCaseType()?.machineName === CLINICAL_NEGLIGENCE_MN;
			sendItem.push({
				stageId: data.stageId,
				stageSortOrder: data.stageSortOrder,
				damages: data.damages,
				premiumSubSettingCommissions: premiumSubSettings,
				premium: premiumSettings.psType === PS_TYPE_PERCENTAGE ? 0 : premium,
				// GPL AC1/AC2/AC3/AC5 - GPL (Green/LEI) policies do not use Underwriter Premiums; forced
				// to zero here so the submit preview matches what the backend clamp (see
				// PremiumSettingsService/PercentagePremiumSettingsService/ApplicationService) will
				// actually persist, the same way the PS_TYPE_PERCENTAGE amount is already zeroed above.
				underwriterRate: (premiumSettings.psType === PS_TYPE_PERCENTAGE || isGplSolicitorGroup) ? 0 : underwriterRate,
				underwriterRatePercentage: isGplSolicitorGroup ? 0 : underwriterRatePercentage,
				recoverable: isClinicalNegligence ? recoverable : null,
				nonRecoverable: isClinicalNegligence ? nonRecoverable : null,
				premiumType: data.isNonContingent ? PREMIUM_TYPE.NON_CONTINGENT.key : PREMIUM_TYPE.CONTINGENT.key,
			});
		});
		return sendItem;
	};

	const handleSubmitStep6 = (evt) => {
		evt.preventDefault();
		if (isApplicationPremium && isChangingStatusOfApp) {
			dispatch(requestPatchApplicationPremiumSettings({
				sendBody: {
					id: premiumSettingsWizard.editId,
					notes: premiumSettingsWizard.notes,
					comments: premiumSettingsWizard.comments,
					endorsements: premiumSettingsWizard.endorsements,
					applicationPremiumSubSettingsDtos: getPremiumSubSetting(),
					limitOfIndemnity: parseFloat(premiumSettingsWizard.limitOfIndemnity),
					isPercentagePremium: premiumSettingsWizard.isPercentagePremium,
					recoverableRatePercentage: premiumSettingsWizard.recoverableRatePercentage,
					DeductibleOptionId: premiumSettingsWizard.selectedDeductible,
					CoverageOptionId: premiumSettingsWizard.selectedCoverageType,
					EndorsementOptionId: premiumSettingsWizard.selectedEndorsement,
				},
				applicationId: applicationId,
				makeApplicationLive: true,
				sendEmail: sendEmail
			}));
			return;
		}

		if (isApplicationPremium && !isChangingStatusOfApp) {
			dispatch(requestPatchApplicationPremiumSettings({
				sendBody: {
					id: premiumSettingsWizard.editId,
					notes: premiumSettingsWizard.notes,
					comments: premiumSettingsWizard.comments,
					endorsements: premiumSettingsWizard.endorsements,
					applicationPremiumSubSettingsDtos: getPremiumSubSetting(),
					limitOfIndemnity: parseFloat(premiumSettingsWizard.limitOfIndemnity),
					isPercentagePremium: premiumSettingsWizard.isPercentagePremium,
					recoverableRatePercentage: premiumSettingsWizard.recoverableRatePercentage,
					DeductibleOptionId: premiumSettingsWizard.selectedDeductible,
					CoverageOptionId: premiumSettingsWizard.selectedCoverageType,
					EndorsementOptionId: premiumSettingsWizard.selectedEndorsement,
				},
				applicationId: applicationId
			}));
			return;
		}

		if (premiumSettingsWizard.isEditMode) {
			dispatch(requestPatchPremiumSetting({
				id: premiumSettingsWizard.editId,
				validFrom: premiumSettingsWizard.validFrom.toDateString(),
				validUntil: premiumSettingsWizard.validUntil ? premiumSettingsWizard.validUntil.toDateString() : null,
				notes: premiumSettingsWizard.notes,
				comments: premiumSettingsWizard.comments,
				endorsements: premiumSettingsWizard.endorsements,
				premiumSubSettings: premiumSettings.psType === PS_TYPE_PERCENTAGE ? [] : getPremiumSubSetting(),
				percentagePremiumSubSettings: premiumSettings.psType === PS_TYPE_PERCENTAGE ? getPremiumSubSetting() : [],
				limitOfIndemnity: parseFloat(premiumSettingsWizard.limitOfIndemnity),
				recoverableRatePercentage: premiumSettingsWizard.recoverableRatePercentage,
				caseTypeId: premiumSettingsWizard.caseTypeId,
				subCaseTypeId: premiumSettingsWizard.subCaseTypeId,
				solicitorGroupId: premiumSettingsWizard.solicitorGroupId,
				workSourceId: premiumSettingsWizard.workSourceId,
				DeductibleOptionId: premiumSettingsWizard.selectedDeductible,
				CoverageOptionId: premiumSettingsWizard.selectedCoverageType,
				EndorsementOptionId: premiumSettingsWizard.selectedEndorsement,
				premiumSettingTypePercentage: premiumSettings.psType === PS_TYPE_PERCENTAGE,
			}));
		}
		else {
			dispatch(postNewPremiumSettingWizard({
				validFrom: premiumSettingsWizard.validFrom.toDateString(),
				validUntil: premiumSettingsWizard.validUntil ? premiumSettingsWizard.validUntil.toDateString() : null,
				notes: premiumSettingsWizard.notes,
				comments: premiumSettingsWizard.comments,
				endorsements: premiumSettingsWizard.endorsements,
				premiumSubSettings: premiumSettings.psType === PS_TYPE_PERCENTAGE ? [] : getPremiumSubSetting(),
				percentagePremiumSubSettings: premiumSettings.psType === PS_TYPE_PERCENTAGE ? getPremiumSubSetting() : [],
				limitOfIndemnity: parseFloat(premiumSettingsWizard.limitOfIndemnity),
				solicitorGroupId: selectedSolicitorGroup === '' ? null : parseInt(selectedSolicitorGroup),
				caseTypeId: parseInt(selectedCaseTypeRedux),
				subCaseTypeId: selectedSubCaseType === '' || selectedSubCaseType === '0' ? null : parseInt(selectedSubCaseType),
				workSourceId: selectedWorksource === '' ? null : parseInt(selectedWorksource),
				DeductibleOptionId: premiumSettingsWizard.selectedDeductible,
				CoverageOptionId: premiumSettingsWizard.selectedCoverageType,
				EndorsementOptionId: premiumSettingsWizard.selectedEndorsement,
				recoverableRatePercentage: premiumSettingsWizard.recoverableRatePercentage,
				premiumSettingTypePercentage: premiumSettings.psType === PS_TYPE_PERCENTAGE,
			}));
		}
	};

	// --- Selection getter methods ---

	const getSelectedCaseType = () => {
		if (
			premiumSettingsWizard.caseTypeName
			&& premiumSettingsWizard.isEditMode
		) {
			return caseTypes.find(item => item.name === premiumSettingsWizard.caseTypeName);
		}

		if (selectedApplicationCaseTypeId) {
			return caseTypes.find(item => item.id.toString() === selectedApplicationCaseTypeId.toString());
		}

		if (selectedCaseTypeRedux) {
			return caseTypes.find(item => item.id.toString() === selectedCaseTypeRedux.toString());
		}

		return null;
	};

	const getSelectedSubCaseTypeName = () => {
		if (
			premiumSettingsWizard.subCaseTypeName
			&& premiumSettingsWizard.isEditMode
		) {
			return getSelectedCaseType()?.subCaseTypes.find(item => item.name === premiumSettingsWizard.subCaseTypeName);
		}

		const caseType = _.find(caseTypes, item => item.id.toString() === selectedCaseTypeRedux);

		if (caseType) {
			const subCaseType = _.find(caseType.subCaseTypes, item => item.id.toString() === selectedSubCaseType);
			return subCaseType || null;
		} else {
			return null;
		}
	};

	const getSolicitorGroupName = () => {
		if (
			premiumSettingsWizard.solicitorGroupName
			&& premiumSettingsWizard.isEditMode
		) {
			return premiumSettingsWizard.solicitorGroupName;
		}
		return selectedSolicitorGroupName;
	};

	// Mirrors getSolicitorGroupName so the read-only selected-group label can
	// keep showing the ARAG Provider colour indicator once past the picker step, including when
	// editing an existing setting. premiumSettings.solicitorGroups is already loaded here, and every
	// entry already carries a resolved .aragProvider object (Task 1/7), so
	// resolveEditedSolicitorGroupAragProvider looks the edited group's provider up from that same
	// list by id rather than needing anything new fetched.
	const getSolicitorGroupAragProvider = () => {
		if (
			premiumSettingsWizard.solicitorGroupName
			&& premiumSettingsWizard.isEditMode
		) {
			return resolveEditedSolicitorGroupAragProvider(premiumSettingsWizard, premiumSettings.solicitorGroups);
		}
		return selectedSolicitorGroupAragProvider;
	};

	const getWorkSourceName = () => {
		if (
			premiumSettingsWizard.workSourceName
			&& premiumSettingsWizard.isEditMode
		) {
			return premiumSettingsWizard.workSourceName;
		}
		return selectedWorksourceName;
	};

	// --- UI event handlers ---

	const onSuggestionChange = (value, action) => {
		if (action.action !== 'input-blur' && action.action !== 'menu-close') {
			if (value.length < 3) {
				dispatch(changeLawsysFirmState('lawsysFirmsFiltered', []));
				dispatch(changeLawsysFirmState('selectedLawsysFirmsDropdown', []));
				changeStoreSettings('selectedSolicitor', '');
			}
			dispatch(changeLawsysFirmState('suggestionFieldValue', value));
		}
	};

	const onSuggestionSelected = (value) => {
		let lawsysFirm = lawsysFirms.lawsysFirmsFiltered.find(x => x.id === value.value);
		dispatch(changeLawsysFirmState('lawsysFirmsFiltered', [lawsysFirm]));
		dispatch(changeLawsysFirmState('selectedLawsysFirmsDropdown', [lawsysFirm]));
		dispatch(changeLawsysFirmState('selectedLawsysFirms', [...lawsysFirms.selectedLawsysFirms, lawsysFirm]));
		changeStoreSettings('selectedSolicitor', value.value);
	};

	const handleEditableData = (newValue, fieldName, objectRow, columnIndex) => {
		if (checkTableDecimal(`${fieldName}-${columnIndex}-${objectRow.stageId ?? ''}-${objectRow.solicitorId ?? ''}-${!!objectRow.isNonContingent}`, newValue)) return;
		// WI 97790: belt and braces. The inputs for these fields are not rendered on a restricted
		// contingent row (see utilFunctions.premiumSettingsTableColumns), so this should be unreachable -
		// but a lock that only exists in the render path is one refactor away from being no lock at all.
		if (lockContingentCommission && !objectRow.isNonContingent
			&& [UNDERWRITER_RATE, UNDERWRITER_RATE_PERCENTAGE, COMMISSION, COMMISSION_PERCENTAGE].includes(fieldName)) {
			return;
		}
		if (isPercentagePremium) {
			handlePercentagePremiumTableChange(
				fieldName, newValue, objectRow, columnIndex, premiumSettingsWizard,
				changeStore2, changeStore3
			);
		} else {
			if (fieldName === PREMIUM || fieldName === UNDERWRITER_RATE || fieldName === UNDERWRITER_RATE_PERCENTAGE) {
				handlePremiumAndUnderwriterChange(newValue, fieldName, objectRow, columnIndex, premiumSettingsWizard, changeStore2, changeStore3, lockContingentCommission, selectedSolicitorGroupInfo.isGplSolicitorGroup);
			} else if (fieldName === RECOVERABLE || fieldName === NON_RECOVERABLE) {
				handleRecoverableAndNonRecoverableChange(newValue, fieldName, objectRow, columnIndex, premiumSettingsWizard, changeStore2);
			} else if (fieldName === COMMISSION || fieldName === COMMISSION_PERCENTAGE) {
				handleCommissionChange(newValue, fieldName, objectRow, columnIndex, premiumSettingsWizard, changeStore3);
			}
		}
	};

	const handleCancelWizard = () => {
		dispatch(routerGoBack());
		clearSuccessMsg(location);
	};

	const handleChangeWizardStep = (type) => {
		// Going back leaves whatever's on the current step behind — clear any
		// lingering "too many decimals" messages so they don't reappear stale
		// if the user revisits that step later.
		clearTableErrors();
		dispatch(changeWizardStep(type));
	};

	// --- Render ---

	let handleSubmit;
	switch (premiumSettingsWizard.currentStep) {
		case 1:
			handleSubmit = handleSubmitStep1;
			break;
		case 2:
			handleSubmit = handleSubmitStep2;
			break;
		case 3:
			handleSubmit = handleSubmitStep3;
			break;
		case 4:
			if (isPercentagePremium) {
				handleSubmit = handleSubmitPercentageStep4;
			}
			else {
				handleSubmit = handleSubmitStep4;
			}
			break;
		case 5:
			handleSubmit = handleSubmitStep5;
			break;
		case 6:
			handleSubmit = handleSubmitStep6;
			break;
		default:
			handleSubmit = handleSubmitStep1;
	}
	const steps = [
		{name: CONTENT_STRINGS.STAGES, stepNumber: 1},
		{name: CONTENT_STRINGS.DAMAGE_BANDS, stepNumber: 2},
		{name: CONTENT_STRINGS.COMMISSIONS, stepNumber: 3},
		{name: CONTENT_STRINGS.PREMIUMS, stepNumber: 4},
		{name: CONTENT_STRINGS.LOI_AND_NOTES, stepNumber: 5},
		{name: CONTENT_STRINGS.OVERVIEW, stepNumber: 6},
	];

	const headerData = getTableHeaderData(premiumSettingsWizard.damageBands, damages);
	const topHeader = CONTENT_STRINGS.DAMAGES;
	// GPL AC1/AC4 - lock the Underwriter Rate/Amount cells to zero and disabled when the group is
	// Green/LEI, for this wizard's readonly Overview step. isUnderwriterPremiumLocked is a parameter
	// threaded per call site, not a property of premiumSettingsTableColumns itself - other callers of
	// readonlyPremiumSettingsTableColumns (e.g. premiumSettingsCombinationTable.js,
	// applicationPremiumSettingsFunctions.js's buildRevisionTableProps) still default it to false and
	// are unaffected by this change; wiring those is out of this task's scope.
	const columns = readonlyPremiumSettingsTableColumns(headerData, isPercentagePremium, showTable, isApplicationPremium, undefined, undefined, selectedSolicitorGroupInfo.isGplSolicitorGroup);
	// WI 99823 AC1/AC2: when Non-Contingent is locked, the premium table renders Contingent-only - the
	// headers and rows are both derived from these filtered values (and getPremiumSubSetting reuses
	// effectiveTableData for the payload) so the toggle, the table and the save all agree.
	const effectiveSelectedNonContingentCaseStages = nonContingentLocked
		? []
		: premiumSettingsWizard.selectedNonContingentCaseStages;
	const effectiveTableData = nonContingentLocked
		? premiumSettingsWizard.tableData.filter(d => !d.isNonContingent)
		: premiumSettingsWizard.tableData;
	const verticalHeaders = calculateVerticalHeaders(premiumSettingsWizard.selectedCaseStages, effectiveSelectedNonContingentCaseStages);
	const outerVerticalHeaders = showNonContingentToggle ? calculateOuterVerticalHeaders(premiumSettingsWizard.selectedCaseStages, effectiveSelectedNonContingentCaseStages) : null;
	const groups = calculateGroupColumns(columns);
	const data = handlePremiumSettingsTableData(effectiveTableData, getSelectedCaseType(), isPercentagePremium, showTable, isApplicationPremium);
	// GPL AC1/AC4 - same lock for the editable wizard step (Custom/Percentage wizard step 4).
	const editableColumns = editablePremiumSettingsColumns(headerData, handleEditableData, isPercentagePremium, emptyField, tableErrors, lockContingentCommission, selectedSolicitorGroupInfo.isGplSolicitorGroup);
	const loiTestId = isApplicationPremium ? APPLICATION_PREMIUM_SETTINGS_LOI_TEST_ID : PREMIUM_SETTINGS_LOI_TEST_ID;
	const notesTestId = isApplicationPremium ? APPLICATION_PREMIUM_SETTINGS_NOTES_TEST_ID : PREMIUM_SETTINGS_NOTES_TEST_ID;
	const commentsTestId = isApplicationPremium ? APPLICATION_PREMIUM_SETTINGS_COMMENTS_TEST_ID : PREMIUM_SETTINGS_COMMENTS_TEST_ID;
	const endorsementsTestId = isApplicationPremium ? APPLICATION_PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID : PREMIUM_SETTINGS_ENDORSEMENTS_TEST_ID;
	const coverageTestId = isApplicationPremium ? APPLICATION_PREMIUM_SETTINGS_COVERAGE_TEST_ID : PREMIUM_SETTINGS_COVERAGE_TEST_ID;
	const deductiblesTestId = isApplicationPremium ? APPLICATION_PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID : PREMIUM_SETTINGS_DEDUCTIBLE_TEST_ID;
	
	const tableTestId = isApplicationPremium ? APPLICATION_PREMIUM_SETTINGS_TABLE_TEST_ID : PREMIUM_SETTINGS_TABLE_TEST_ID;
	const highlightedColumnsToUse = highlightColumnPropertyName ? [highlightColumnPropertyName] : undefined;
	const navItems = steps.map((step, i) => ({ key: (i + 1).toString(), label: step.name }));
    const validFromLabel = premiumSettingsWizard.validFrom && 
						new Date(premiumSettingsWizard.validFrom).toLocaleDateString(LOCALE_UK) + 
						(premiumSettingsWizard.validUntil 
							? (' - ' + new Date(premiumSettingsWizard.validUntil).toLocaleDateString(LOCALE_UK)) 
							: '');
	// All previous versions of this application premium setting, newest first
	const applicationPremiumSettingsRevisions = premiumSettingsWizard.revisions;

	// Table columns/groups/headers for the selected history modal — built from the revision's own damage bands
	const revisionTableProps = selectedPreviousUpdate
		? buildRevisionTableProps(
			selectedPreviousUpdate, isPercentagePremium, props.showTable, props.isApplicationPremium,
			damages, getSelectedCaseType(), showNonContingentToggle, topHeader, data,
		)
		: null;

	// Table rows for the show-table view (sharedStep6 with showTable=true), annotated with EMPHASIZED_FIELDS
	// on cells that differ from revisions[0] (the most recent previous version). WI 99823: fed
	// effectiveTableData, not the raw store value, so its rows stay aligned with verticalHeaders (which
	// nonContingentLocked has already stripped of Non-Contingent stages) - the pairing is positional, so
	// an unfiltered extra row shifts every stage label.
	const appPremiumSettingsShowTableData = handleAnnotatedPremiumSettingsTableData(
		effectiveTableData,
		premiumSettingsWizard.revisions[0]?.applicationPremiumSubSettingsDtos,
		EMPHASIZED_FIELDS,
		getSelectedCaseType(), isPercentagePremium, props.showTable, props.isApplicationPremium
	);

	// Position of the selected history item in the revisions array — used to find its predecessor
	const selectedRevisionIndex = selectedPreviousUpdate
		? applicationPremiumSettingsRevisions?.findIndex(r => r.id === selectedPreviousUpdate.id) ?? -1
		: -1;
	// DTOs of the revision that preceded the selected history item, used as the diff baseline in the modal
	const compareDtosForHistory = applicationPremiumSettingsRevisions[selectedRevisionIndex + 1]?.applicationPremiumSubSettingsDtos;
	// Table rows for the history modal, annotated with HIGHLIGHTED_FIELDS on cells that differ from the revision before it
	const appPremiumSettingsHistoryItemData = handleAnnotatedPremiumSettingsTableData(
		selectedPreviousUpdate?.applicationPremiumSubSettingsDtos,
		compareDtosForHistory,
		HIGHLIGHTED_FIELDS,
		getSelectedCaseType(), isPercentagePremium, props.showTable, props.isApplicationPremium
	);

	// FormGroup emphasis map for the show-table view — fields that changed vs the most recent previous revision
	// null when no revisions exist yet (first-ever save has nothing to compare against)
	const appPremiumSettingsEmphasizedFields = premiumSettingsWizard.revisions?.length > 0
		? applicationPremiumSettingsShowTableFields(
			premiumSettingsWizard.fetchedApplicationPremium,  // raw API payload — same shape/types as revision DTOs
			premiumSettingsWizard.revisions[0]
		)
		: null;
	// FormGroup highlight map for the history modal — fields that changed vs the revision before the selected one
	// null for the oldest revision (no predecessor) and when no history item is selected
	const appPremiumSettingsHighlightedFields = (selectedPreviousUpdate && selectedRevisionIndex >= 0 && selectedRevisionIndex + 1 < applicationPremiumSettingsRevisions.length)
		? applicationPremiumSettingsShowTableFields(
			selectedPreviousUpdate,
			applicationPremiumSettingsRevisions[selectedRevisionIndex + 1]
		)
		: null;

	const highlightedRows = isApplicationPremium
		? verticalHeaders
				.filter(h =>
					h.outerHeaderId === NON_CONTINGENT
						? h.machineName === highlightedNonContingentStageMachineName
						: h.machineName === highlightedContingentStageMachineName
				)
				.map(h => h.id)
		: [];

	return (
		<PremiumSettingsWizard
			onCancelAppPremiumSettings={onCancel}
			appPremiumSettingsIndicator={appPremiumSettingsIndicator}
			handleSubmitStep6={handleSubmitStep6}
			isChangingStatusOfApp={isChangingStatusOfApp}
			applicationPremiumCancelHandler={applicationPremiumCancelHandler}
			applicationPremiumSaveButtonLabel={applicationPremiumSaveButtonLabel}
			onApplicationPremiumEdit={onApplicationPremiumEdit}
			isApplicationPremium={isApplicationPremium}
			pig={pig}
			onApplyPig={onApplyPig}
			handleCancelWizard={handleCancelWizard}
			premiumSettingTypeCustom={premiumSettingType === PS_TYPE_CUSTOM}
			isPercentagePremium={isPercentagePremium}
			commissionAddDisabled={commissionAddDisabled}
			showTable={showTable}
			fetchingCaseTypes={fetchingCaseTypes}
			selectedSubCaseType={getSelectedSubCaseTypeName()}
			selectedCaseType={getSelectedCaseType()}
			selectedSolicitorGroupName={getSolicitorGroupName()}
			selectedSolicitorGroupAragProvider={getSolicitorGroupAragProvider()}
			selectedWorksourceName={getWorkSourceName()}
			removeSolicitor={removeSolicitor}
			addSolicitor={addSolicitor}
			solicitorGroupAragProviderId={selectedSolicitorGroupInfo.aragProviderId}
			getEndDamageBands={getEndDamageBands}
			getStartDamageBands={getStartDamageBands}
			setDamageBand={setDamageBand}
			removeDamageBand={removeDamageBand}
			getDamageBandName={(band) => getDamageBandName(band, damages)}
			steps={steps}
			handleSubmit={handleSubmit}
			changeStoreSettings={changeStoreSettings}
			handleCaseStagesSelectMultipleChange={handleCaseStagesSelectMultipleChange}
			handleCaseStagesCheckedState={handleCaseStagesCheckedState}
			showNonContingentToggle={showNonContingentToggle}
			hasNonContingentPremium={premiumSettingsWizard.hasNonContingentPremium}
			handleToggleNonContingent={handleToggleNonContingent}
			handleNonContingentCaseStagesChange={handleNonContingentCaseStagesChange}
			handleNonContingentCaseStagesCheckedState={handleNonContingentCaseStagesCheckedState}
			premiumSettingsWizard={premiumSettingsWizard}
			changeWizardStep={handleChangeWizardStep}
			decimalErrors={tableErrors}
			checkDecimal={checkTableDecimal}
			lawsysFirms={lawsysFirms}
			fetchingDamages={fetchingDamages}
			caseStages={caseStages}
			fetchingStages={fetchingStages}
			selectedCoverageType={premiumSettingsWizard.selectedCoverageType}
			selectedDeductible={premiumSettingsWizard.selectedDeductible}
			selectedEndorsement={premiumSettingsWizard.selectedEndorsement}
			displayedCoverageType={premiumSettingsWizard.displayedCoverageType}
			displayedDeductible={premiumSettingsWizard.displayedDeductible}
			displayedEndorsement={premiumSettingsWizard.displayedEndorsement}
			coveragesOptions={premiumSettingsWizard.coveragesOptions}
			deductiblesOptions={premiumSettingsWizard.deductiblesOptions}
			endorsementsOptions={premiumSettingsWizard.endorsementsOptions}
			onSuggestionSelected={onSuggestionSelected}
			onSuggestionChange={onSuggestionChange}
			changeLawsysFirmState={(key, value) => dispatch(changeLawsysFirmState(key, value))}
			validationMessage={emptyField || premiumSettingsWizard.validationMessage}
			sortDamageBands={sortDamageBands}
			currentStep={premiumSettingsWizard.currentStep}
			failedToFetchMessage={premiumSettingsWizard.failedToFetchMessage}
			columns={columns}
			topHeader={topHeader}
			verticalHeaders={verticalHeaders}
			outerVerticalHeaders={outerVerticalHeaders}
			groups={groups}
			data={data}
			editableColumns={editableColumns}
			loiTestId={loiTestId}
			notesTestId={notesTestId}
			commentsTestId={commentsTestId}
			endorsementsTestId={endorsementsTestId}
			tableTestId={tableTestId}
			highlightedColumnsToUse={highlightedColumnsToUse}
			navItems={navItems}
			wizardLoiTestId={PREMIUM_SETTINGS_WIZARD_LOI_TEST_ID}
			wizardNotesTestId={PREMIUM_SETTINGS_WIZARD_NOTES_TEST_ID}
			wizardCommentsTestId={PREMIUM_SETTINGS_WIZARD_COMMENTS_TEST_ID}
			wizardEndorsementsTestId={PREMIUM_SETTINGS_WIZARD_ENDORSEMENTS_TEST_ID}
			wizardTableTestId={PREMIUM_SETTINGS_WIZARD_TABLE_TEST_ID}
			validFromLabel={validFromLabel}
			loggedInUser={loggedInUser}
			highlightedRows={highlightedRows}
			applicationPremiumSettingsRevisions={applicationPremiumSettingsRevisions}
			openModal={premiumSettingsWizard.openRevisionsModal}
			setOpenModal={(val) => changeStoreSettings('openRevisionsModal', val)}
			selectedPreviousUpdate={selectedPreviousUpdate}
			setSelectedPreviousUpdate={setSelectedPreviousUpdate}
			revisionTableProps={revisionTableProps}
			appPremiumSettingsHistoryItemData={appPremiumSettingsHistoryItemData}
			appPremiumSettingsShowTableData={appPremiumSettingsShowTableData}
			appPremiumSettingsEmphasizedFields={appPremiumSettingsEmphasizedFields}
			appPremiumSettingsHighlightedFields={appPremiumSettingsHighlightedFields}
			deductiblesTestId={deductiblesTestId}
			coverageTestId={coverageTestId}
			wizardDeductiblesTestId={PREMIUM_SETTINGS_WIZARD_DEDUCTIBLE_TEST_ID}
			wizardCoverageTestId={PREMIUM_SETTINGS_WIZARD_COVERAGE_TEST_ID}
			nonContingentLocked={nonContingentLocked}
		/>
	);
};

export default PremiumSettingsWizardHOC;
